import treeMenu from './tree-menu';

export function exec() {
    treeMenu();
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/tree-menu/index.js